export const SELECTOR = 'recent-events';

export const RECENT_EVENTS_PARAMS = [
  {
    name: 'limit',
    items: [{ value: 4, include: true }],
  },
  {
    name: 'tag',
    items: [{ value: 'object-events', include: true }],
  },
  {
    name: 'o',
    items: [{ value: '-updated_at_first', include: true }],
  },
];

export const RECENT_EVENTS_FIELDS = [
  'id',
  'headline',
  'url',
  'sitewide_image',
  'ap_pub_date',
  'ap_updated_date',
];

export const RECENT_EVENTS_API_URL = '/api/v2/articles/';
